import { api } from '@/trpc/client';

export const useTenantApi = () => {
  const utils = api.useUtils();
  const getTenants = api.tenant.all.useQuery;

  const switchCurrentTenant = api.tenant.switchCurrentTenant.useMutation({
    onSuccess: () => {
      void utils.invalidate();
    },
    onMutate: ({ tenantId }) => {
      utils.tenant.all.setData(undefined, (data) => {
        const selectedTenant = data?.tenants.find(
          (tenant) => tenant.id === tenantId,
        );
        return {
          tenants: data?.tenants ?? [],
          activeTenant: selectedTenant ?? null,
          defaultTenant: data?.defaultTenant ?? null,
        };
      });
    },
    onError: () => {
      void utils.tenant.all.invalidate();
    },
  });

  return {
    getTenants,
    switchCurrentTenant,
  };
};
